<template>
  <div class="hideTotal">
    <!-- 搜索 -->
    <table-search
      label-width="65px"
      @search="fetchList(1)"
      @reset="handleReset"
    >
      <template v-slot:basic>
        <!-- <el-form-item label="组织">
          <el-select
            v-model="query.marketId"
            placeholder="请选择组织"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.organization"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item> -->
        <el-form-item label="订变">
          <el-select
            v-model="query.entrustTs"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.entrustTs"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="购销计划">
          <el-input
            v-model="query.goodsCode"
            style="width:45%;float:left"
            placeholder="近期购销计划代码"
          />
          <span style="position: absolute; left: 49%">&</span>
          <el-input
            v-model="query.goodsCodeOther"
            style="width:45%;float:right"
            placeholder="远期购销计划代码"
          />
        </el-form-item>
        <el-form-item label="购销类型">
          <el-select
            v-model="query.entrustBs"
            placeholder="请选择"
          >
            <el-option
              v-for="(item, index) in $key.spotPurchaseSaleInquiry.entrustBs"
              :key="index"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="成交日期"
          class="datePicker"
        >
          <el-date-picker
            v-model="query.date"
            is-range
            arrow-control
            type="daterange"
            range-separator="至"
            start-placeholder="起始成交日期"
            end-placeholder="截止成交日期"
            placeholder="选择时间范围"
          />
        </el-form-item>
      </template>
    </table-search>
    <!-- 导出 -->
    <inquery-result isTips @export="toDownload" />
    <!-- 表格 -->
    <el-table :data="tableData">
      <el-table-column
        fixed
        label="序号"
        align="center"
        width="70px"
      >
        <template slot-scope="scope">
          {{ scope.$index+1 }}
        </template>
      </el-table-column>
      <!-- <af-table-column
        fixed
        prop="marketName"
        label="组织"
      /> -->
      <af-table-column
        fixed
        prop="userAccount"
        label="客户"
      />
      <af-table-column
        fixed
        prop="tradeUserAccount"
        label="客户号"
      />
      <af-table-column
        prop="userName"
        label="客户名称"
      />
      <af-table-column
        prop="areaName"
        label="区域"
      />
      <af-table-column
        prop="entrustTsName"
        label="订/变"
      />
      <af-table-column
        prop="entrustBsName"
        label="购/销"
      />
      <af-table-column
        prop="goodsCode"
        label="购销计划"
      />
      <af-table-column
        prop="goodsCodeOther"
        label="套利购销计划"
      />
      <af-table-column
        prop="entrustNo"
        label="委托编号"
      />
      <af-table-column
        prop="businessNo"
        label="成交编号"
      />
      <af-table-column
        prop="tradingDate"
        label="成交日期"
      />
      <af-table-column
        prop="businessTimeStr"
        label="成交时间"
      />
      <af-table-column
        prop="entrustWayName"
        label="委托方式"
      />
      <af-table-column
        prop="entrustTypeName"
        label="委托类型"
      />
      <af-table-column
        prop="businessAmount"
        label="成交量"
      />
      <af-table-column
        prop="businessPrice"
        label="成交价格"
      />
      <af-table-column
        prop="presentChangeWarehouse"
        label="变今量"
      />
      <af-table-column
        prop="tradeCompanyCode"
        label="贸易公司"
      />
    </el-table>
    <el-pagination
      class="pagination"
      layout="total, prev, pager, next"
      :current-page.sync="currentPage"
      :total="total"
      background
      @current-change="changePage"
    />
  </div>
</template>
<script>
import api from '@/api'
import dayJs from 'dayjs'

function Query () {
  this.marketId = '000' // 组织编号
  this.goodsCode = '' // 近期购销计划代码
  this.goodsCodeOther = '' // 远期购销计划代码
  this.entrustBs = '' // 购销类型
  this.date = [] // 成交日期
  this.entrustTs = '' // 订变
}
export default {
  name: 'HistoricalArbitrageTransactionDetails',
  data () {
    return {
      query: new Query(),

      currentPage: 1,
      total: 0,
      pageSize: 10,
      marketId: '',
      tableData: [], // 表格数据
    }
  },
  mounted () {
    this.fetchList(1)
  },
  methods: {
    // 分页查询
    async fetchList (currentPage, pageSize) {
      if (pageSize) {
        this.pageSize = pageSize
      }
      this.currentPage = currentPage || this.currentPage || 1
      let param = {
        ...this.query,
        currentPage: this.currentPage,
        pageSize: this.pageSize
      }
      param.startDate = this.query.date.length ? dayJs(this.query.date[0]).format('YYYYMMDD') : ''
      param.endDate = this.query.date.length ? dayJs(this.query.date[1]).format('YYYYMMDD') : ''
      let res = await api.spotPurchaseSaleInquiry.HistoricalArbitrageTransactionDetailInquiry(param)
      this.total = res.data.totalItem
      this.tableData = res.data.items
      this.marketId = this.query.marketId
    },
    // 重置搜索
    handleReset () {
      this.query = new Query()
      this.fetchList(1)
    },
    // 导出
    toDownload () {
      let param = {
        marketId: this.marketId,
        execlType: '20',
        excelHead: [
          // {
          //   fieldLabel: '组织',
          //   excelColumn: 'marketName'
          // },
          {
            fieldLabel: '客户',
            excelColumn: 'userAccount'
          },
          {
            fieldLabel: '客户号',
            excelColumn: 'tradeUserAccount'
          },
          {
            fieldLabel: '客户名称',
            excelColumn: 'userName'
          },
          {
            fieldLabel: '区域',
            excelColumn: 'areaName'
          },
          {
            fieldLabel: '订/变',
            excelColumn: 'entrustTsName'
          },
          {
            fieldLabel: '购/销',
            excelColumn: 'entrustBsName'
          },
          {
            fieldLabel: '购销计划',
            excelColumn: 'goodsCode'
          },
          {
            fieldLabel: '套利购销计划',
            excelColumn: 'goodsCodeOther'
          },
          {
            fieldLabel: '委托编号',
            excelColumn: 'entrustNo'
          },
          {
            fieldLabel: '成交编号',
            excelColumn: 'businessNo'
          },
          {
            fieldLabel: '成交日期',
            excelColumn: 'tradingDate'
          },
          {
            fieldLabel: '成交时间',
            excelColumn: 'businessTimeStr'
          },
          {
            fieldLabel: '委托方式',
            excelColumn: 'entrustWayName'
          },
          {
            fieldLabel: '委托类型',
            excelColumn: 'entrustTypeName'
          },
          {
            fieldLabel: '成交量',
            excelColumn: 'businessAmount'
          },
          {
            fieldLabel: '成交价格',
            excelColumn: 'businessPrice'
          },
          {
            fieldLabel: '变今量',
            excelColumn: 'presentChangeWarehouse'
          },
          {
            fieldLabel: '贸易公司名称',
            excelColumn: 'tradeCompanyCode'
          }
        ]
      }
      this.$utils.getExcelFile(this, api.download, param)
    },
    changePage (page) {
      this.fetchList(page)
    }
  }
}

</script>
<style lang="scss" scoped>
  .hideTotal ::v-deep .el-col.el-col-24.el-col-sm-24.el-col-md-6:nth-child(2) {
    width: 550px;
  }

  .hideTotal ::v-deep > .el-table .el-table__body-wrapper tbody>tr:last-child {
    td:nth-child(12) div {
      display: none;
    }
  }

  .hideTotal ::v-deep .el-table__fixed-body-wrapper:first-child tbody tr:last-child {
    td:nth-child(2) div {
      display: none
    }
  }

</style>
